import {useLocation} from "react-router-dom";

export function useUrlParamExists(param: string, value?: string) {
    const {search} = useLocation();
    const searchParams = new URLSearchParams(search);
    if (value == null) {
        return searchParams.has(param);
    }
    return searchParams.get(param) === value;
}
